export default __webpack_public_path__ + "static/media/classMatrix.894930e4.png";